import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaYoutube, FaPinterest, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaRegClock } from 'react-icons/fa';
import logo from '../../assets/images/logo/logo-green.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__grid">
          <div className="footer__brand">
            <img src={logo} alt="Tokyo Byokane Philippines" className="footer__logo" />
            <p className="footer__tagline">Fastening Your Innovations</p>
            <p className="footer__desc">
              Warehousing and distribution of mechanical and electrical parts.
              Your one-stop shop for industrial fasteners.
            </p>
            <div className="footer__socials">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" aria-label="Pinterest"><FaPinterest /></a>
            </div>
          </div>

          <div className="footer__nav">
            <h4 className="footer__heading">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/branches">Our Branches</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/company-profile">Company Profile (PDF)</Link></li>
            </ul>
          </div>

          <div className="footer__products">
            <h4 className="footer__heading">Products</h4>
            <ul>
              <li><Link to="/products">Standard Products</Link></li>
              <li><Link to="/products">Precision Screws</Link></li>
              <li><Link to="/products">Thread Forming</Link></li>
              <li><Link to="/products">SEMS Screws</Link></li>
              <li><Link to="/products">Springs</Link></li>
              <li><Link to="/products">Cutting Parts</Link></li>
            </ul>
          </div>

          <div className="footer__contact">
            <h4 className="footer__heading">Contact Info</h4>
            <ul>
              <li>
                <FaMapMarkerAlt className="footer__icon" />
                <span>Lot C2-6B Carmelray Industrial Park 2, Brgy. Punta, Calamba City, Laguna 4027</span>
              </li>
              <li>
                <FaPhoneAlt className="footer__icon" />
                <span>+63-49-508-7899 / 7903 / 7904</span>
              </li>
              <li>
                <FaEnvelope className="footer__icon" />
                <span>sales@tokyobyokane.com.ph</span>
              </li>
              <li>
                <FaRegClock className="footer__icon" />
                <span>Mon–Fri 8:00–17:00 PHT</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Tokyo Byokane Philippines Corporation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
